import auth from '@/authfile';
import useAcvDatadog from '@/composables/useAcvDatadog';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.fullPath === '/logout') {
    return;
  }
  const config = useRuntimeConfig();
  const auth0 = await auth(
    config.public.AUTH0_DOMAIN,
    config.public.AUTH0_CLIENT_ID,
    config.public.REDIRECT_URL,
    config.public.AUTH0_AUDIENCE,
  );

  const { addRumError } = useAcvDatadog();
  const isAuthenticated = await auth0.isAuthenticated();

  if (!isAuthenticated) {
    localStorage.removeItem('magic_link_token');

    const query = to?.query;

    if (query && query.code && query.state) {
      return await auth0.handleRedirectCallback();
    } else {
      // Do not set cached path for /check-email, /legal and /logout routes
      if (to.fullPath !== '/check-email' && to.fullPath !== '/legal' && to.fullPath !== '/logout') {
        // cache the path so we can redirect after authenticating
        localStorage.setItem('cachedPath', JSON.stringify(to.fullPath));
      }
      await auth0.loginWithRedirect();
      return abortNavigation('Login required');
    }
  }

  // get token and set in localstorage
  const token = await auth0.getTokenSilently();
  localStorage.setItem('access_token', token);

  // Extract and store user email from Auth0 token
  // This is used during the signup process because user information is not available in our system yet
  const tokenString = config.public.AUTH0_CLIENT_ID;
  let authToken;
  try {
    authToken = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${tokenString}::transport-load-board::openid profile email`,
      ),
    );
    localStorage.setItem('user_email', authToken.body?.decodedToken?.user?.email);
  } catch (e) {
    addRumError('Failed to parse user email from auth token', {
      error: e,
      authToken,
      tokenString,
    });
  }

  const hash = window?.location?.hash;

  if (hash.includes('access_token')) {
    const params = new URLSearchParams(hash.substring(1));

    const magicLinkToken = params.get('access_token');

    if (magicLinkToken) {
      localStorage.setItem('magic_link_token', magicLinkToken);
    }
  } else if (hash.includes('error')) {
    // Handle error if needed
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    console.error('Error during authentication:', error, errorDescription);
  }
});
